<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M4 4.333a1 1 0 000 2h18.667a1 1 0 100-2H4zM18.667 13a5.667 5.667 0 100 11.333 5.667 5.667 0 000-11.333zM11 18.667a7.667 7.667 0 1113.749 4.668l3.958 3.958a1 1 0 01-1.414 1.414l-3.958-3.958A7.667 7.667 0 0111 18.667zM3 12a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zm1 5.667a1 1 0 100 2h3.333a1 1 0 100-2H4z"/></svg>